const style = (theme): any => ({
    enabledColor: {
        backgroundColor: theme.palette.colors.green,
    },
    disabledColor: {
        backgroundColor: theme.palette.colors.red,
    },
    bubble: {
        borderRadius: 20,
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 8,
        paddingRight: 8,
        marginLeft: 16,
        marginRight: 16,
        textAlign: 'center',
        color: theme.palette.primary.contrastText,
        fontWeight: 'bold',
    },
    title: {
        fontSize: 34,
        fontWeight: 900,
    },
    anchor: {
        marginRight: 8,
        paddingRight: 12,
        paddingLeft: 12,
        paddingTop: 8,
        paddingBottom: 8,
        backgroundColor: theme.palette.colors.grey,
        borderRadius: 25,
        color: theme.palette.colors.black,
        fontWeight: 'bold',
        textDecoration: 'none',
    },
    anchors: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
});
export default style;
